import PropTypes from 'prop-types';

export const LoggedInUserPropType = PropTypes.shape({
    ID: PropTypes.string,
    Guest: PropTypes.bool,
    UserName: PropTypes.string,
    FirstName: PropTypes.string,
    LastName: PropTypes.string,
    DisplayName: PropTypes.string,
    isMember: PropTypes.bool,
    hasSubscription: PropTypes.bool,
    Roles: PropTypes.arrayOf(PropTypes.string),
    UserLogins: PropTypes.arrayOf(
        PropTypes.shape({
            LoginProvider: PropTypes.string
        })
    )
});
